/**
 * Created by josh on 2017/8/11.
 */

import Button from './src/button.vue';

/* istanbul ignore next */
Button.install = function(Vue) {
    Vue.component(Button.name, Button);
};

export default Button;


// WEBPACK FOOTER //
// ./src/plugin-api/packages/button/index.js